const isLive = window.location.hostname === 'panorama-one.silhouette.com';
const server = isLive ? 'auth.silhouette.com' : 'testauth.silhouette.com';

const recaptchaSiteKey = '6LenuVYdAAAAAJTSmW5E2xe17Ke5sucNNRQwv6Lr';

export default {
  server,
  recaptchaSiteKey,
};
